import {useSearchParams} from 'react-router-dom';
import {sha256} from 'js-sha256';
import {setUserToken} from '../../../utils/api';

export const useAttentamente2024Auth = <K extends string>(surveyParamNames: K[]) => {
    const [searchParams] = useSearchParams();

    const container = searchParams.get('container_id');
    const uoaId = searchParams.get('uoa_id');
    const token = searchParams.get('token');
    const surveyIds = Object.fromEntries(surveyParamNames.map((name) => [name, searchParams.get(name)])) as Record<K, string | null>;

    if (token) {
        setUserToken(token);
    }

    const isAuthorized = !!(
        container &&
        uoaId &&
        searchParams.get('key') === sha256(process.env.REACT_APP_HASH_KEY_ATTENTAMENTE_PARENT || '') &&
        surveyParamNames.every((name) => surveyIds[name])
    );

    return {container, uoaId, surveyIds, isAuthorized};
};
